import Vue from 'vue'

import './css/vendor.scss'
import './css/login.scss'

import Login from './pages/login.vue'
// Vendor skipped in vendor.js
import './vendor.js'

// If not supported don't render anything
if (document.getElementById('old').style.display === 'none') {
    
    var vm = new Vue({
        render: h => h(Login)
    })

    vm.$mount('#body');
}